import React from 'react';
import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { translate } from 'react-admin';
import { stringify } from 'query-string';


const styles = {
    icon: { paddingRight: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
};

const LinkToRelatedPurchase = ({ classes, record }) => (
    <Button
        size="small"
        color="primary"
        component={Link}
        to={{
            pathname: '/purchase',
            search: stringify({
                page: 1,
                perPage: 10,
                filter: JSON.stringify({ user_id:record.id }),
            }),
        }}
        className={classes.link}
    >
        {record.email}
    </Button>
);

const enhance = compose(
    withStyles(styles),
    translate
);
export default enhance(LinkToRelatedPurchase);